<nz-page-header nzTitle="Claim payment list"></nz-page-header>
<div class="row mt-3">
	<div class="col">
		<app-table
			[data]="data"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[filters]="filters"
			[loading]="loading"
			[disablePaging]="false"
			(onUpdateRequired)="doFetchResults($event)">
		</app-table>
	</div>
</div>
